export default {
    app: {
        name: 'Zunox',
        researchEdition: 'Forskningsutgåva',
    },
    nav: {
        activity: 'Aktivitet',
        loading: 'Läser in...',
        noActivityReports: 'Inga aktivitetsrapporter är tillgängliga. Kontrollera att både en AFK-bevakare och en fönsterbevakare körs.',
        timeline: 'Tidslinje',
        stopwatch: 'Stoppur',
        tools: 'Verktyg',
        search: 'Sök',
        workReport: 'Arbetsrapport',
        aiSummary: 'AI-sammanfattning',
        trends: 'Trender',
        report: 'Rapport',
        alerts: 'Aviseringar',
        timespiral: 'Tidsspiral',
        query: 'Fråga',
        graph: 'Graf',
        rawData: 'Rådata',
        settings: 'Inställningar',
    },
    footer: {
        madeWith: 'Skapad med',
        byDevs: 'av Zunox-utvecklarna',
        host: 'Värd:',
        version: 'Version:',
        reportBug: 'Rapportera ett fel',
        askHelp: 'Be om hjälp',
        voteFeatures: 'Rösta på funktioner',
        twitter: 'Twitter',
        github: 'GitHub',
        reddit: 'Reddit',
        donate: 'Donera',
    },
    common: {
        loading: 'Läser in...',
        save: 'Spara',
        cancel: 'Avbryt',
        confirm: 'Bekräfta',
        import: 'Importera',
        export: 'Exportera',
        open: 'Öppna',
        more: 'Mer',
        delete: 'Ta bort',
        enabled: 'Aktiverad',
        disabled: 'Inaktiverad',
        home: 'Hem',
        language: 'Språk',
        languageUk: 'Українська',
        languageEn: 'English',
        languageDe: 'Deutsch',
        languageRu: 'Русский',
        languageZhCN: '简体中文',
        languageSv: 'Svenska',
        rangeTo: 'till',
    },
    notFound: {
        title: 'Hoppsan, sidan kunde inte hittas!',
        hint: 'Försök gå tillbaka till sidan du kom från.',
    },
    settings: {
        title: 'Inställningar',
        unsavedCategoriesLeave: 'Dina kategorier har osparade ändringar. Är du säker på att du vill lämna sidan?',
        daystart: {
            startOfDay: 'Dagens början',
            startOfDayHelp: 'Tidpunkten då dagar "börjar", eftersom människor inte alltid går och lägger sig före midnatt. Standardvärdet är 04:00.',
            startOfWeek: 'Veckans början',
            startOfWeekHelp: 'Veckodagen som inleder en ny vecka.',
            saturday: 'Lördag',
            sunday: 'Söndag',
            monday: 'Måndag',
        },
        timelineDuration: {
            title: 'Standardvärde för varaktighet',
            help: "Standardvaraktigheten som används för 'visa senaste' i tidslinjevyn.",
        },
        landingPage: {
            title: 'Startsida',
            home: 'Hem',
            activity: 'Aktivitet ({hostname})',
            timeline: 'Tidslinje',
            help: 'Sidan som öppnas när du öppnar Zunox eller klickar på logotypen i toppmenyn.',
        },
        theme: {
            title: 'Tema',
            auto: 'Automatiskt (system)',
            light: 'Ljust',
            dark: 'Mörkt',
            help: 'Ändra färgtema. Kategorifärger väljs separat — du kan behöva justera dem när du växlar till mörkt läge.',
        },
        groups: {
            general: 'Allmänt',
            generalHelp: 'Standardvärden som styr hur tidsperioder, tidslinjen och startsidan fungerar.',
            appearance: 'Utseende',
            appearanceHelp: 'Tema och färger för visualiseringar.',
            categorization: 'Kategorisering',
            categorizationHelp: 'Regler som klassificerar händelser i kategorier samt åsidosättanden för AFK- och aktivitetsmönster.',
            privacy: 'Integritet',
            privacyHelp: 'Filter som tar bort eller maskerar känsliga händelsedata innan de lagras.',
            developer: 'Utvecklare',
        },
        language: {
            title: 'Språk',
            help: 'Gränssnittsspråk för webbgränssnittet.',
        },
        releaseNotification: {
            title: 'Sök efter nya versioner',
            help: 'När detta är aktiverat söker webbgränssnittet en gång per dag efter en ny Zunox-version och visar ett meddelande om en finns.',
        },
        color: {
            title: 'Använd reservfärger',
            help: 'Använder den äldre färgsättningen för vissa visualiseringar när data är okategoriserad eller saknar kategorifärg.',
        },
        activePattern: {
            title: 'Räkna alltid som aktivt mönster',
            help1: 'Appar eller titlar som matchar detta reguljära uttryck räknas aldrig som AFK.',
            help2: 'Kan användas för att räkna tid som aktiv trots avsaknad av inmatning (t.ex. möten eller spel med handkontroll). En tom sträng inaktiverar funktionen.',
            example: 'Exempel på uttryck:',
            invalid: 'Ogiltigt mönster',
            tooBroad: 'Mönstret är för brett',
        },
        categorization: {
            title: 'Kategorisering',
            restoreDefaults: 'Återställ standardvärden',
            rulesHelp: 'Regler för kategorisering av händelser. En händelse kan bara tillhöra en kategori. Om flera kategorier matchar väljs den mest specifika.',
            builderIntro: 'Du kan använda',
            categoryBuilder: 'kategoribyggaren',
            builderOutro: 'för att snabbt skapa kategorier från okategoriserad aktivitet.',
            forumIntro: 'Du kan också hitta och dela förinställningar för kategoriseringsregler på',
            forum: 'forumet',
            docsIntro: 'För hjälp med hur kategoriseringsregler skrivs, se',
            documentation: 'dokumentationen',
            categorySet: 'Kategoriuppsättning:',
            newSet: 'Ny uppsättning',
            deleteSet: 'Ta bort uppsättning',
            setsAvailable: '{count} uppsättningar tillgängliga — byt uppsättning för att använda olika regelprofiler.',
            unsavedChanges: 'Du har osparade ändringar!',
            discard: 'Ignorera',
            addCategory: 'Lägg till kategori',
            categories: 'Kategorier',
            priority: 'Prioritet',
            priorityDefault: 'Standard',
            priorityInteger: 'Prioriteten måste vara ett heltal.',
            builderTitle: 'Kategoribyggare',
            builderSubtitle: 'Skapa regler från okategoriserad aktivitet',
            openBuilder: 'Öppna byggaren',
            hideBuilder: 'Dölj byggaren',
        },
        developer: {
            title: 'Utvecklarinställningar',
            note: 'Obs!',
            noteBody: 'De här inställningarna är avsedda för utvecklare som (förhoppningsvis) vet vad de gör och kan därför oväntat få saker att sluta fungera.',
            forceDevmode: 'Tvinga utvecklarläge',
            forceDevmodeHelp: 'Utvecklarläget aktiverar vissa funktioner som fortfarande är under utveckling.',
            showYearly: 'Visa årligt tidsintervall',
            showYearlyHelp: 'Att fråga efter ett helt år är en mycket tung operation och leder sannolikt till timeout. Frågan kan dock vara tillräckligt snabb om du kör aw-server-rust.',
            multidevice: 'Använd fråga för flera enheter',
            multideviceHelp: 'En fråga för flera enheter samlar händelser från flera värdar i aktivitetsvyn. Det är ett tidigt experiment som för närvarande inte stöder webbläsarbuckets eller funktionen som räknar hörbart innehåll som aktivt.',
            requestTimeout: 'Timeout för begäran',
            requestTimeoutHelp: 'Den maximala tid en serverbegäran får ta innan den avbryts. Ett högt värde kan vara användbart för stora frågor. Observera att webbgränssnittet måste läsas om för att ändringen ska börja gälla.',
            commitHash: 'Commit-hash för webbgränssnittet:',
        },
    },
    home: {
        note: 'Obs!',
        androidNote: 'Zunox för Android är fortfarande i ett mycket tidigt utvecklingsskede. Det kommer att finnas fel, men vi hoppas att du har tålamod medan vi förbättrar det och får det i nivå med skrivbordsversionen av Zunox (som du borde prova!).',
        greeting: 'Välkommen till Zunox',
        intro1: 'Vi har kommit långt{android}, men vi behöver fortfarande användare (som du!) som ger återkoppling och hjälper oss att göra Zunox till ett framgångsrikt projekt. Vi tar gärna emot idéer på förbättringar.',
        introAndroid: ' (särskilt på Android!)',
        intro3: 'Om du är utvecklare hoppas vi att du kan bidra genom att skriva en bevakare, visualisering eller något annat och dela det med oss på forumet!',
        thanks: 'Tack för att du använder Zunox!',
        surveyFill: 'Fyll i vår användarundersökning',
        surveySuffix: 'för att hjälpa till att forma vad som kommer härnäst.',
        surveyOr: 'eller',
        voteForum: 'rösta på funktioner på forumet',
        spreadTitle: 'Sprid ordet',
        spread1: 'Inget är lika motiverande som att få Zunox i händerna på fler användare. Genom att dela det hjälper du oss att göra Zunox ännu bättre!',
        spreadReview: 'Gilla och recensera oss på',
        spreadVote: 'Rösta på oss på',
        spreadFollow: 'Följ oss och sprid ordet på',
        spreadStar: 'Stjärnmärk oss på',
        supportTitle: 'Stöd oss!',
        subscribeIntro: 'Det bästa sättet att hålla Zunox underhållet är en prenumeration — från 5 USD/månad. Alla funktioner förblir kostnadsfria och du kan avsluta när som helst.',
        subscribeCta: 'Stöd Zunox →',
        support1: 'Gillar du Zunox? Har det hjälpt dig? Hjälp oss att hjälpa dig genom att donera! Du kan donera via:',
        support2: 'Mer information finns på',
        donationPage: 'donationssidan på webbplatsen',
        otherDonationMethods: 'Andra metoder (inkl. kryptovaluta)',
        resourcesTitle: 'Resurser',
        website: 'Webbplats',
        documentation: 'Dokumentation',
        forum: 'Forum',
        discord: 'Discord',
        reddit: 'Reddit',
        apiBrowser: 'API-webbläsare',
        workingOnTitle: 'Det här arbetar vi med',
        workingOnPrefix: 'Håll dig uppdaterad med',
        devUpdates: 'utvecklingsuppdateringarna',
        workingOnMiddle: 'och följ projektet på',
        workingOnSuffix: 'för versionsinformation.',
        landingHint: 'Du kan ändra vilken sida som öppnas när du öppnar Zunox (i stället för den här sidan) i',
        supporterNudge: {
            message: 'Du verkar få mycket nytta av Zunox — skulle du kunna tänka dig att stödja utvecklingen?',
            support: 'Stöd Zunox →',
            notNow: 'Inte nu',
        },
    },
    buckets: {
        title: 'Buckets',
        moreWatchers: 'Vill du samla in mer data? Ta en titt på',
        docsLink: 'dokumentationen',
        thisDevice: 'den här enheten',
        lastUpdatedInline: 'Senast uppdaterad',
        noEventsYet: 'Inga händelser registrerade ännu',
        noEvents: 'inga händelser',
        moreActionsFor: 'Fler åtgärder för {hostname}',
        deleteAllTitle: 'Ta bort alla {count} buckets för {hostname}',
        deleteAllForHost: 'Ta bort alla buckets för den här värden',
        openBucket: 'Öppna bucket',
        deleteBucketTitle: 'Ta bort bucket?',
        deleteHostTitle: 'Ta bort buckets?',
        deleteHostTitleNamed: 'Ta bort alla buckets för {hostname}?',
        deleteHostConfirmPrefix: 'Är du säker på att du vill ta bort',
        deleteHostConfirmCount: 'alla {count} buckets',
        deleteHostConfirmSuffix: 'för värden "{hostname}"?',
        bucketsToDelete: 'Buckets som kommer att tas bort:',
        deleting: 'Tar bort...',
        importing: 'Importerar...',
        importHelpNew: 'Ange en JSON-fil som exporterats från en enskild bucket eller från flera buckets. Importen misslyckas om en bucket med samma ID redan finns.',
        exportHelp: 'Hämta alla buckets på den här servern som en enda JSON-fil. Använd detta för säkerhetskopior.',
        currentDevice: '(den aktuella enheten)',
        lastUpdated: 'Senast uppdaterad:',
        firstSeen: 'Först sedd:',
        bucketId: 'Bucket-ID',
        updated: 'Uppdaterad',
        exportBucketJson: 'Exportera bucket som JSON',
        exportEventsCsv: 'Exportera händelser som CSV',
        deleteBucket: 'Ta bort bucket',
        deleteModalTitle: 'Fara!',
        deleteConfirm: 'Är du säker på att du vill ta bort bucket "{id}"?',
        deletePermanent: 'Detta är permanent och kan inte ångras!',
        importExportTitle: 'Importera och exportera buckets',
        importBuckets: 'Importera buckets',
        importPlaceholder: 'Välj eller släpp en fil här...',
        importDrop: 'Släpp filen här...',
        importHelp: 'En giltig fil för import är en JSON-fil från antingen en export av en enskild bucket eller en export av flera buckets. Om det redan finns buckets med samma namn misslyckas importen.',
        exportBuckets: 'Exportera buckets',
        exportAllJson: 'Exportera alla buckets som JSON',
        tools: 'Verktyg',
    },
    activity: {
        title: 'Aktivitet',
        for: 'för',
        host: 'Värd:',
        timeActive: 'Aktiv tid:',
        queryRange: 'Frågeintervall:',
        filters: 'Filter',
        filtersTitle: 'Filter',
        refresh: 'Uppdatera',
        excludeAfk: 'Uteslut AFK-tid',
        audibleActive: 'Räkna hörbar webbläsarflik som aktiv',
        includeStopwatch: 'Inkludera manuellt loggade händelser (stoppur)',
        newView: 'Ny vy',
        loadDemo: 'Läs in demodata',
        periodDay: 'dag',
        periodWeek: 'vecka',
        periodMonth: 'månad',
        periodYear: 'år',
        periodLast7d: '7 dagar',
        periodLast30d: '30 dagar',
        periodLast7dTitle: 'senaste 7 dagarna',
        periodLast30dTitle: 'senaste 30 dagarna',
        filterAfkTooltip: 'Filtrera bort tid då AFK-bevakaren inte upptäckte någon inmatning.',
        filterAudibleTooltip: 'Om det aktiva fönstret är en hörbar webbläsarflik räknas den som aktiv. Kräver en webbläsarbevakare.',
        showCategory: 'Visa kategori',
        newViewTitle: 'Ny vy',
        viewId: 'ID',
        viewName: 'Namn',
        stopwatchWipNote: 'Obs! Pågående arbete. Stoppurshändelser ersätter andra händelser när de överlappar. Visas endast i utvecklarläge.',
        invalidForm: 'Ogiltig formulärinmatning: {errors}',
        errIdNotUnique: 'ID:t är inte unikt',
        errMissingId: 'ID saknas',
        errMissingName: 'Namn saknas',
    },
    activityView: {
        addVisualization: 'Lägg till visualisering',
        cancel: 'Avbryt',
        save: 'Spara',
        restoreDefaults: 'Återställ standardvärden',
        remove: 'Ta bort',
        editView: 'Redigera vy',
        restoreAlert: 'Alla vyer har återställts till standardvärdena. Ändringarna sparas inte förrän du klickar på Spara.',
        removeViewTitle: 'Ta bort den här vyn?',
        removeViewOk: 'Ta bort vy',
        removeViewConfirm: 'Är du säker på att du vill ta bort',
        removeViewHint: 'Detta tar bort vyns konfiguration. Du kan köra',
        removeViewRestoreHint: 'för att återställa de inbyggda vyerna.',
        promptWatcher: 'Ange bevakarens namn',
        promptTitle: 'Ange visualiseringens titel',
    },
    uncategorized: {
        title: 'Mycket okategoriserad tid',
        body: 'Du har totalt {duration} okategoriserad tid, vilket är {percent}% av all tid {period}.',
        hint: 'Du kan åtgärda detta genom att använda',
        categoryBuilder: 'kategoribyggaren',
        settingsCogTitle: 'Dölj eller justera den här tipsrutan i Inställningar',
        periodToday: 'i dag',
        periodThisWeek: 'den här veckan',
        periodThisMonth: 'den här månaden',
        periodThisYear: 'det här året',
        periodLast7d: 'de senaste 7 dagarna',
        periodLast30d: 'de senaste 30 dagarna',
    },
    visualizations: {
        noData: '(inga data)',
        unsupportedPeriod: 'Den här funktionen stöder inte den aktuella tidsperioden.',
        missingWatcher: 'Den här funktionen saknar data från en nödvändig bevakare.',
        docLink: 'dokumentation',
        allCategories: 'Alla',
        topApps: 'Vanligaste programmen',
        topTitles: 'Vanligaste fönstertitlarna',
        topDomains: 'Vanligaste webbläsardomänerna',
        topUrls: 'Vanligaste webbadresserna',
        topBrowserTitles: 'Vanligaste webbläsartitlarna',
        topEditorFiles: 'Vanligaste redigerarfilerna',
        topEditorLanguages: 'Vanligaste redigerarspråken',
        topEditorProjects: 'Vanligaste redigerarprojekten',
        topCategories: 'Vanligaste kategorierna',
        categoryTree: 'Kategoriträd',
        categorySunburst: 'Kategorisol',
        timelineBarchart: 'Tidslinje (stapeldiagram)',
        sunburstClock: 'Solur',
        dailyTimeline: 'Daglig tidslinje (kronologisk)',
        customVis: 'Anpassad visualisering',
        score: 'Poäng',
        topStopwatches: 'Vanligaste stoppurshändelserna',
        topBucketData: 'Vanligaste bucket-data',
    },
    timeline: {
        title: 'Tidslinje',
        eventsShown: 'Visade händelser:',
        swimlanes: 'Banor:',
        filterAfk: 'Filtrera AFK',
        mergeByApp: 'Slå ihop efter program',
        noEvents: 'Inga händelser matchar de valda kriterierna. Tidslinjen har inte uppdaterats.',
        scrollHint: 'Rulla för att zooma, svep/rulla horisontellt för att panorera, använd piltangenterna för att navigera',
        loading: 'Läser in...',
    },
    stopwatch: {
        title: 'Stoppur',
        usingBucket: 'Använder bucket:',
        aboutTitle: 'Om stoppuret',
        aboutBody: 'Spåra manuellt loggade sessioner tillsammans med automatisk spårning. Om du vill se stoppurssummor på en instrumentpanel öppnar du en aktivitetsvy, klickar på Redigera vy, sedan Lägg till visualisering och väljer Vanligaste stoppurshändelserna.',
        placeholder: 'Vad arbetar du med?',
        noRunning: 'Inget stoppur körs. Starta ett ovan för att registrera fokuserat arbete.',
        start: 'Starta',
        running: 'Körs',
        history: 'Historik',
    },
    search: {
        title: 'Sök',
        earlyDev: 'Den här funktionen är fortfarande i ett tidigt utvecklingsskede.',
        searchBtn: 'Sök',
        options: 'Alternativ',
        notFound: 'Hittade du inte det du letade efter?',
        addWeek: 'Lägg till en vecka i sökningen:',
        addWeekBtn: '+1 vecka',
    },
    query: {
        title: 'Frågeutforskare',
        docsHelp: 'Se dokumentationen för hjälp med hur frågor skrivs.',
        start: 'Start',
        end: 'Slut',
    },
    workReport: {
        title: 'Arbetstidsrapport',
        loading: 'Läser in...',
    },
    report: {
        title: 'Rapport',
        description: 'Skapa en rapport över tid som lagts på en viss kategori av enhetsaktivitet.',
        earlyDev: 'Den här funktionen är fortfarande i ett tidigt utvecklingsskede.',
        generate: 'Skapa',
        options: 'Alternativ',
        foundEvents: 'Hittade {count} händelser på {seconds} sekunder',
        csv: 'CSV',
    },
    trends: {
        titlePrefix: 'Trender för',
        earlyDev: 'Den här funktionen är fortfarande i ett tidigt utvecklingsskede.',
        loadDemo: 'Läs in demodata',
    },
    timespiral: {
        title: 'Tidsspiral',
        wip: 'Det här är ett experiment under utveckling.',
        noAfkBucket: 'Ingen AFK-bucket hittades på den här värden. Installera',
        noAfkBucketSuffix: 'för att använda Tidsspiralen.',
        bucketLabel: 'Bucket:',
        eventsLabel: 'Händelser:',
    },
};
